import axios from 'axios';
import { API_CONFIG } from '../config/env';

export interface WalletBalance {
  address: string;
  usdcBalance: number;
  maticBalance: number;
}

class WalletService {
  private getAuthHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async getWalletBalance(address: string): Promise<WalletBalance> {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/Wallets/${address}/balance`, {
        headers: this.getAuthHeaders(),
      });
      return response.data;
    } catch (error) {

      throw error;
    }
  }
}

export const walletService = new WalletService();
